import React, { useEffect } from 'react';
import './Template1.css';
import html2pdf from 'html2pdf.js';

const Template1 = ({ formData }) => {
    useEffect(() => {
        const updateHeight = () => {
            const container = document.querySelector('.template-container');
            const containerWidth = container.offsetWidth;
            const containerHeight = containerWidth * 1.41421; // A4 paper width-to-height ratio
            container.style.minHeight = `${containerHeight}px`;
        };

        // Call updateHeight initially and add event listener for window resize
        updateHeight();
        window.addEventListener('resize', updateHeight);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', updateHeight);
        };
    }, []);
    return (
        <div className="template-container">
            <div className="text-center">
                {formData.Details.map((detail, index) => (
                    <div key={index} className="profile-container">
                        {detail.profileImage && <img src={detail.profileImage} alt="Profile" className="profile-image" />}
                        <h2 className="profile-name">{detail.fullName}</h2>
                        <p>{detail.email}{detail.phoneNumber && ` | ${detail.phoneNumber}`}{detail.address && ` | ${detail.address}`}</p>
                        <p>{detail.website}{detail.linkedin && ` | ${detail.linkedin}`}{detail.github && ` | ${detail.github}`}</p>
                        <p dangerouslySetInnerHTML={{ __html: detail.about }} />
                    </div>
                ))}
            </div>
            <p className="watermark">PREVIEW</p>
            {formData.edu_flag &&
                <div className="section">
                    {formData.education.length !== 0 ?(<h3 className="section-title">Education</h3>):(null)}
                    {formData.education.map((edu, index) => (
                        <div key={index} className="section-content">
                            <p className="bold-text">{edu.degree} - {edu.college} - {edu.location}</p>
                            <p>{edu.fromYear} - {edu.toYear}</p>
                        </div>
                    ))}
                </div>
            }
            {formData.Work_flag &&
                <div className="section">
                    {formData.experience.length !== 0 ?(<h2 className="section-title">Work Experience</h2>):(null)}
                    {formData.experience.map((exp, index) => (
                        <div key={index} className="section-content">
                            <p className="bold-text">{exp.jobRole} at {exp.companyName}</p>
                            <p>{exp.companyLocation}</p>
                            <p>{exp.fromYear} - {exp.toYear}</p>
                            <p dangerouslySetInnerHTML={{ __html: exp.jobDescription }} />
                        </div>
                    ))}
                </div>
            }
            {formData.skill_flag &&
                <div className="section">
                    {formData.skills.length !== 0 ?(<h2 className="section-title">Skills</h2>):(null)}
                    {formData.skills.map((skill, index) => (
                        <div key={index} className="section-content">
                            <p><span className="bold-text">{skill.title}</span> - {skill.skill_list}</p>
                        </div>
                    ))}
                </div>
            }
            {formData.pro_flag &&
                <div className="section">
                    {formData.addprojects.length !== 0 ?( <h2 className="section-title">Project Developed Or Handled</h2>):(null)}
                    {formData.addprojects.map((prodit, index) => (
                        <div key={index} className="section-content">
                            <p className="bold-text">{prodit.projectname} - {prodit.projectplatform}</p>
                            <p dangerouslySetInnerHTML={{ __html: prodit.description }} />
                        </div>
                    ))}
                </div>
            }
            {formData.ach_flag &&
                <div className="section">
                    {formData.achivawards.length !== 0 ?(<h2 className="section-title">Achievements & Awards</h2>):(null)}
                    {formData.achivawards.map((ach, index) => (
                        <div key={index} className="section-content">
                            <p>{ach.achivawards}</p>
                        </div>
                    ))}
                </div>
            }
            {formData.add_flag &&
                <div className="section">
                    <h2 className="section-title">Additional Information</h2>
                    {formData.addinfodatas.map((addinfo, index) => (
                        <div key={index} className="section-content">
                            <p>{addinfo.addinfodata}</p>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};

export default Template1;
